import { ChangeDetectionStrategy, Component, input} from '@angular/core';
import { LucideDynamicIcon } from '@lucide/angular';
import { Branding } from '@features/auth/models/branding.model';


@Component({
  selector: 'app-branding-panel',
  imports: [LucideDynamicIcon],
  templateUrl: './branding-panel.html',
  host: {
    class: 'flex flex-1 w-full min-w-0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandingPanel {
  readonly branding = input.required<Branding>();
}
